<template>
  <div>
    <label for="text">
      City
      <span class="star" v-if="displayRequired">*</span>
    </label>
    <el-select
      v-loading="getCitiesLoading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      placeholder="Select City"
      v-model="city.city"
      filterable
      :filter-method="updatFilter"
      default-first-option
      :disabled="!city.state"
      clearable
    >
      <el-option
        v-for="city in filterCities"
        :key="city"
        :label="city"
        :value="city"
      />
    </el-select>
    <p class="err" v-if="validataionErrors && validataionErrors[errorKey]">
      {{ validataionErrors[errorKey] }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("help", [
      "getAllCities",
      "getCitiesLoading",
      "getStateChanged",
    ]),
    getErrorKey() {
      return `city`;
    },
    filterCities() {
      if (this.filterString && this.filterString.length) {
        return [...this.getAllCities].filter(
          (option) =>
            option.toLowerCase().indexOf(this.filterString.toLowerCase()) == 0
        );
      } else {
        return [...this.getAllCities];
      }
    },
  },
  props: {
    cityData: { required: true },
    validataionErrors: { required: false },
    errorKey: { required: false },
    displayRequired: { default: true },
  },
  data() {
    return {
      filteredCities: [],
      includeCurrentPayor: true,
      filterString: "",
      city: "",
    };
  },
  async mounted() {
    this.city = this.cityData;
  },
  methods: {
    setAllCities() {
      this.filteredCities = [...this.getAllCities];
    },

    updatFilter(filterValue) {
      this.filterString = filterValue;
    },
  },

  watch: {
    cityData: {
      immediate: true,
      deep: true,
      handler: function () {
        this.city = this.cityData;
      },
    },
  },
};
</script>

<style scoped>
.err {
  margin-top: 2px !important;
  color: #eb5757;
  font-size: 12px;
  min-height: 20px;
  white-space: nowrap;
  margin-bottom: -30px;
  line-height: 20px;
  font-weight: 500;
  padding-left: 2px;
}
</style>
